import { render, staticRenderFns } from "./ProductsCardNotavailable.vue?vue&type=template&id=1d2c85ac&scoped=true&"
import script from "./ProductsCardNotavailable.vue?vue&type=script&lang=js&"
export * from "./ProductsCardNotavailable.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCardNotavailable.vue?vue&type=style&index=0&id=1d2c85ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2c85ac",
  null
  
)

export default component.exports